import { generateClient } from 'aws-amplify/api';
import { useCallback, useState } from 'react';
import { SUBMIT_SURVEY } from '../../graphql';
import type { SurveyInput, SurveyResult, SurveyStatus } from '../../types';
import logger from '../../utils/logger';

export function useSurveySubmission() {
  const client = generateClient();
  const [status, setStatus] = useState<SurveyStatus>('idle');
  const [result, setResult] = useState<SurveyResult | null>(null);

  const submit = useCallback(async (input: SurveyInput) => {
    logger.info('Submitting survey', { sessionId: input.sessionId, email: input.email });
    setStatus('sending');
    try {
      const res: any = await client.graphql({ query: SUBMIT_SURVEY, variables: { input } });
      const surveyResult = res.data.submitSurvey;
      setResult({ postcardUrl: surveyResult.postcardUrl, email: surveyResult.email });
      setStatus('sent');
      logger.info('Survey submitted successfully', { sessionId: input.sessionId, postcardUrl: surveyResult.postcardUrl });
    } catch (err) {
      logger.error('Survey submission error', err);
      setStatus('error');
    }
  }, []);

  const reset = useCallback(() => {
    logger.info('Resetting survey submission state');
    setStatus('idle');
    setResult(null);
  }, []);

  return { status, result, submit, reset };
}
